var _circle, _circle2, _circle3, _circle4, _circle5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoading(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#333333",
    stroke: "#333333",
    strokeWidth: 30,
    r: 15,
    cx: 35,
    cy: 100
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    calcMode: "spline",
    dur: 1.2,
    values: "35;165;165;35;35",
    keySplines: "0 .1 .5 1;0 .1 .5 1;0 .1 .5 1;0 .1 .5 1",
    repeatCount: "indefinite",
    begin: 0
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#333333",
    stroke: "#333333",
    strokeWidth: 30,
    opacity: 0.8,
    r: 15,
    cx: 35,
    cy: 100
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    calcMode: "spline",
    dur: 1.2,
    values: "35;165;165;35;35",
    keySplines: "0 .1 .5 1;0 .1 .5 1;0 .1 .5 1;0 .1 .5 1",
    repeatCount: "indefinite",
    begin: 0.05
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    fill: "#333333",
    stroke: "#333333",
    strokeWidth: 30,
    opacity: 0.6,
    r: 15,
    cx: 35,
    cy: 100
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    calcMode: "spline",
    dur: 1.2,
    values: "35;165;165;35;35",
    keySplines: "0 .1 .5 1;0 .1 .5 1;0 .1 .5 1;0 .1 .5 1",
    repeatCount: "indefinite",
    begin: 0.1
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    fill: "#333333",
    stroke: "#333333",
    strokeWidth: 30,
    opacity: 0.4,
    r: 15,
    cx: 35,
    cy: 100
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    calcMode: "spline",
    dur: 1.2,
    values: "35;165;165;35;35",
    keySplines: "0 .1 .5 1;0 .1 .5 1;0 .1 .5 1;0 .1 .5 1",
    repeatCount: "indefinite",
    begin: 0.15
  }))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    fill: "#333333",
    stroke: "#333333",
    strokeWidth: 30,
    opacity: 0.2,
    r: 15,
    cx: 35,
    cy: 100
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    calcMode: "spline",
    dur: 1.2,
    values: "35;165;165;35;35",
    keySplines: "0 .1 .5 1;0 .1 .5 1;0 .1 .5 1;0 .1 .5 1",
    repeatCount: "indefinite",
    begin: 0.2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.8fa0329f.svg";
export { ForwardRef as ReactComponent };